<script setup lang="ts">
import FadeTransition from '@/shared/components/transitions/FadeTransition.vue'
import SkeletonLoader from '@/shared/components/loader/SkeletonLoader.vue'

interface Props {
  open: boolean
  loading?: boolean
}

defineProps<Props>()
</script>

<template>
  <FadeTransition>
    <div
      v-if="open"
      class="z-10 absolute mt-px border-b border-x border-gray-300 bg-white dark:border-gray-800 dark:bg-black w-full overflow-x-hidden max-h-64 focus:outline-none shadow-md"
    >
      <ul v-if="loading">
        <li class="p-2">
          <SkeletonLoader class="w-8/9 h-5" />
        </li>
        <li class="p-2">
          <SkeletonLoader class="w-1/2 h-5" />
        </li>
        <li class="p-2">
          <SkeletonLoader class="w-3/4 h-5" />
        </li>
      </ul>
      <slot v-else></slot>
    </div>
  </FadeTransition>
</template>
